import React, { createContext, useContext, useEffect, useState } from 'react';

import { JsonRecord } from 'libs/cms/parse/types';

type SwaggerComponent = Record<string, any>;

type SwaggerState = {
  isLoading: boolean;
  swagComp: SwaggerComponent | undefined;
};

const SwaggerProvider: React.FC<{
  openApiSpec: JsonRecord;
  expand?: boolean;
  children: React.ReactNode;
}> = ({ openApiSpec, expand, children }) => {
  const [swagComp, setSwagComp] = useState<SwaggerComponent | undefined>(
    undefined,
  );

  useEffect(() => {
    const initSwagger = async () => {
      const SwaggerUI = (await import('swagger-ui')).default;
      const swaggerComponent = SwaggerUI({
        dom_id: '#swag',
        spec: openApiSpec,
        docExpansion: expand ? 'list' : 'none',
        plugins: [HideInfoPlugin, DisableTryItOutDefaultsPlugin],
      });

      setSwagComp(swaggerComponent);
    };

    initSwagger();
  }, [expand, openApiSpec]);

  return (
    <SwaggerContext.Provider value={{ isLoading: !swagComp, swagComp }}>
      {children}
    </SwaggerContext.Provider>
  );
};

const HideInfoPlugin = () => ({
  components: {
    info: () => null,
  },
});

const DisableTryItOutDefaultsPlugin = () => ({
  wrapComponents: {
    JsonSchemaForm:
      (Original: any) =>
      ({ value, ...props }: any) => {
        const Comp = React.createElement(Original, props);
        return Comp;
      },
  },
});

const SwaggerContext = createContext<SwaggerState>({} as SwaggerState);

export const useSwagger = () => useContext(SwaggerContext);

export default SwaggerProvider;
